module.exports = __webpack_public_path__ + "img/youtube.d91bc3fa.svg";